import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';
import { SystemModuleLicenseDto } from 'types';

export const uploadModuleLicense = (
  data: SystemModuleLicenseDto
): Promise<void> => {
  return axios.post('/api/system-modules', data);
};

type UseUploadModuleLicenseOptions = {
  config?: MutationConfig<typeof uploadModuleLicense>;
};

export const useUploadModuleLicense = ({
  config,
}: UseUploadModuleLicenseOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousModuleLicenses) {
        queryClient.setQueryData(
          ['systemModules'],
          context.previousModuleLicenses
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['systemModules']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: uploadModuleLicense,
  });
};
